<template>
  <div class="SubjectList" :style="{ height: height ? `${height}px` : 'auto' }">
    <div style="height: 20px;" v-if="canCheck">
      <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
    </div>
    <div style="margin: 15px 0;"></div>
    <el-checkbox-group v-model="checkedSubjectIds" @change="handleCheckedSubjectIdsChange">
      <virtual-list
          v-if="virtual && !canMove"
          :size='110'
          :remain='height / 110 + 10'
          :style="{ height: `${height - 35}px` }"
        >
        <div :key="`div-subject-item-${item.id}`" class="items" v-for="(item, index) in currentSubjectList">
          <el-checkbox class="subject-list-checkbox" :key="item.id" :label="item.id" v-if="canCheck">{{a}}</el-checkbox>
          <subject-item
              :subject="item"
              :subjectTypeOptions="subjectTypeOptions"
              :wdList="wdList"
              :order="`${ (pageNum - 1) * pageSize + index + 1}/${total}`"
          >
            <div class="subject_item_mover" slot="moveBar" v-if="canMove">
              <i class="el-icon-rank"/>
              <span>拖动此处可改变试题显示顺序</span>
            </div>
            <template v-slot:controls>
              <slot name="listControls" :row="item"></slot>
            </template>
          </subject-item>
        </div>
      </virtual-list>
      <draggable v-else-if="canMove && !virtual" v-model="currentSubjectList" handle=".subject_item_mover" animation="300" @end="moveEnd">
        <transition-group>
          <div :key="`div-subject-item-${subject.id}`" class="items" v-for="(subject, index) in currentSubjectList">
            <el-checkbox class="subject-list-checkbox" :key="subject.id" :label="subject.id">{{a}}</el-checkbox>
            <subject-item
                :subject="subject"
                :subjectTypeOptions="subjectTypeOptions"
                :wdList="wdList"
                :order="`${ (pageNum - 1) * pageSize + index + 1}/${total}`"
            >
              <div class="subject_item_mover" slot="moveBar" v-if="canMove">
                <i class="el-icon-rank"/>
                <span>拖动此处可改变试题显示顺序</span>
              </div>
              <template v-slot:controls>
                <slot name="listControls" :row="subject"></slot>
              </template>
            </subject-item>
          </div>
        </transition-group>
      </draggable>
      <div v-else>
        <div :key="`div-subject-item-${subject.id}`" class="items" v-for="(subject, index) in currentSubjectList">
          <el-checkbox class="subject-list-checkbox" :key="subject.id" :label="subject.id">{{a}}</el-checkbox>
          <subject-item
              :subject="subject"
              :subjectTypeOptions="subjectTypeOptions"
              :wdList="wdList"
              :order="`${ (pageNum - 1) * pageSize + index + 1}/${total}`"
          >
            <div class="subject_item_mover" slot="moveBar" v-if="canMove">
              <i class="el-icon-rank"/>
              <span>拖动此处可改变试题显示顺序</span>
            </div>
            <template v-slot:controls>
              <slot name="listControls" :row="subject"></slot>
            </template>
          </subject-item>
        </div>
      </div>
    </el-checkbox-group>
  </div>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list';
import draggable from 'vuedraggable'
import SubjectItem from "@/components/subjectItem";
export default {
  name: "SubjectList",
  components: {SubjectItem, draggable, VirtualList},
  props: {
    subjectList: {
      type: Array,
      default: () => []
    },
    subjectTypeOptions: {
      type: Array,
      default: () => []
    },
    wdList: {
      type: Array,
      default: () => []
    },
    pageSize: {
      type: Number
    },
    pageNum: {
      type: Number
    },
    total: {
      type: Number
    },
    height: {
      type: Number
    },
    canMove: {
      type: Boolean,
      default: false
    },
    canCheck: {
      type: Boolean,
      default: true
    },
    virtual: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      a: '',
      currentSubjectList: this.subjectList,
      checkedSubjectIds: [],
      checkAll: false
    };
  },
  computed: {
  },
  watch: {
    subjectList(val) {
      this.currentSubjectList = val
      this.checkedSubjectIds = this.checkedSubjectIds.filter(checkedId => val.some(v => v.id === checkedId))
      this.handleCheckedSubjectIdsChange(this.checkedSubjectIds)
    },
    pageNum(val) {
      this.checkedSubjectIds = []
      this.checkAll = false
    },
    checkedSubjectIds(val) {
      this.$emit('selectionChange', this.currentSubjectList.filter(v => val.includes(v.id)))
    }
  },
  mounted() {
  },
  methods: {
    handleCheckedSubjectIdsChange(val) {
      this.checkAll = val.length === this.currentSubjectList.length;
    },
    handleCheckAllChange(val) {
      this.checkedSubjectIds = val ? this.currentSubjectList.map(v => v.id) : [];
    },
    moveEnd({newIndex, oldIndex}) {
      if (newIndex === oldIndex) {
        return
      }
      let oldSort = this.subjectList[oldIndex].sort
      let newSort = this.subjectList[newIndex].sort
      let id = this.subjectList[oldIndex].id
      this.$emit('changeSort', { id, oldSort, newSort }, (res) => {
        if (res) {
          this.$emit('update:subjectList', this.currentSubjectList)
        } else {
          this.currentSubjectList = this.subjectList
        }
      })
    },
    selectItems(ids) {
      this.checkedSubjectIds.push(...ids)
      this.handleCheckedSubjectIdsChange(this.checkedSubjectIds)
    },
    cancelSelectItems(ids) {
      this.checkedSubjectIds = this.checkedSubjectIds.filter(v => !ids.includes(v))
      this.handleCheckedSubjectIdsChange(this.checkedSubjectIds)
    }
  }
};
</script>

<style scoped lang="scss">
.SubjectList {
  overflow: auto;
  ::v-deep .el-scrollbar{
    overflow: hidden;
    height: 100%;
    width: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
      overflow-y: scroll;
      height: 100%;
    }
  }
  .items {
    display: flex;
    padding-bottom: 10px;
  }
  ::v-deep.subject-list-checkbox {
    margin-right: 12px;
    .el-checkbox__input {
      height: 26px;
      display: flex;
      align-items: center;
    }
  }
}
</style>
